import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/Create/tickets.png';
const _withScopeId = n => (_pushScopeId("data-v-8aec3ece"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "lottery-tickets-toast-com"
};
const _hoisted_2 = {
  class: "page"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tickets",
  src: _imports_0,
  alt: ""
}, null, -1));
import { onMounted, getCurrentInstance, computed } from "vue";
export default {
  __name: 'index',
  setup(__props) {
    const {
      $store,
      $router
    } = getCurrentInstance().proxy;
    const show = computed(() => $store.state.lotteryTicketsToastShow);
    const publicKeyAddressStore = computed(() => $store.state.publicKeyAddress);
    onMounted(() => {});
    function goToRouter() {
      $router.push({
        path: "/player/tokenhold/" + publicKeyAddressStore.value
      });
    }
    function onCancel() {
      $store.commit("updateLotteryTicketsToastShow", false);
    }
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_van_toast = _resolveComponent("van-toast");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_toast, {
        class: "lottery-tickets-toast",
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => show.value = $event),
        style: {
          "padding": "0"
        },
        duration: 0,
        "z-index": "2100"
      }, {
        message: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
          "icon-class": "close",
          class: "close",
          onClick: onCancel
        }), _hoisted_3, _createElementVNode("p", null, [_createTextVNode("Congratulations on winning 1 lottery ticket. "), _createElementVNode("span", {
          onClick: goToRouter
        }, "View details")])])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};